export const APPLICATION__ = 'application.*.*';
export const APPLICATION_VIEW_ = 'application.view.*';
export const APPLICATION_EMPLOYEE = 'application.employee.*';
export const APPLICATION_MANAGER = 'application.manager.*';
export const MASTER_MENU_VIEW = 'master.menu.view';
export const MYTEAMS_MENU_VIEW = 'myteams.menu.view';
export const MYPROJECT_MENU_VIEW = 'myproject.menu.view';
export const TIMESHEET_MENU_VIEW = 'timesheet.menu.view';
export const TIMESHEET_CREATE_ = 'timesheet.create.*';
export const TIMESHEET_REVIEW_ = 'timesheet.review.*';
export const TIMESHEET_INVOICE_VIEW = 'timesheet.invoice.view';
export const TIMESHEET_INVOICE_LOCK = 'timesheet.invoice.lock';
export const TIMESHEET_INVOICE_UNLOCK = 'timesheet.invoice.unlock';
export const TIMESHEET_INVOICE_EXPORT = 'timesheet.invoice.export';
export const TIMESHEET_TEAM_APPROVALS = 'timesheet.team.approvals';
export const TIMESHEET_TEAM_COMPLIANCE = 'timesheet.team.compliance';
export const TIMESHEET_TEAM_USERWISE = 'timesheet.team.userwise';
export const TIMESHEET_TEAM_DAYWISE = 'timesheet.team.daywise';
export const ATTENDANCE_MENU_VIEW = 'attendance.menu.view';
export const LEAVES_MENU_VIEW = 'leaves.menu.view';
export const EXPENSES_MENU_VIEW = 'expenses.menu.view';
export const EXPENSES_APPROVAL = 'expence.approve.*';
export const EXPENSES_CATEGORY = 'expence.category.*';
export const EXPENSES_FINANCE_APPROVAL = 'expence.approve.finance';
export const TRAINING_MENU_VIEW = 'training.menu.view';
export const TRAINING_MANAGER = 'training.manager.*';
export const TRAINING_TRAINER = 'training.trainer.*';
export const TRAINING_PEER_REVIEWER = 'training.reviewer.*';
export const TRAINING_BU_HEAD = 'training.buhead.*';
export const TRAINING_HR = 'training.hr.*';
export const TRAINING_ADMIN = 'training.admin.*';
export const LEAVES_CREATE_ = 'leaves.create.*';
export const LEAVES_ADMIN = 'leaves.admin.*';
export const LEAVES_DELETE_ = 'leaves.delete.*';

// Region-wise Leave Admin permissions
export const LEAVES_ADMIN_ESAU = 'leaves.admin.esau.*';
export const LEAVES_ADMIN_ESCA = 'leaves.admin.esca.*';
export const LEAVES_ADMIN_ESIN = 'leaves.admin.esin.*';
export const LEAVES_ADMIN_ESSG = 'leaves.admin.essg.*';
export const LEAVES_ADMIN_ESUK = 'leaves.admin.esuk.*';
export const LEAVES_ADMIN_ESUS = 'leaves.admin.esus.*';
export const LEAVES_ADMIN_ESPH = 'leaves.admin.esph.*';
export const LEAVES_ADMIN_ESIE = 'leaves.admin.esie.*';
export const LEAVES_ADMIN_ESNZ = 'leaves.admin.esnz.*';
export const LEAVES_ADMIN_ESMY = 'leaves.admin.esmy.*';
export const LEAVES_ADMIN_ESNL = 'leaves.admin.esnl.*';

// Each region Leave Admin permission 
export const LEAVES_ADMIN_REGION_MAP = {
  LEAVES_ADMIN_ESAU: { permission: LEAVES_ADMIN_ESAU, locationId: 1, locationCode: 'ESAU' },
  LEAVES_ADMIN_ESCA: { permission: LEAVES_ADMIN_ESCA, locationId: 2, locationCode: 'ESCA' },
  LEAVES_ADMIN_ESIN: { permission: LEAVES_ADMIN_ESIN, locationId: 3, locationCode: 'ESIN' },
  LEAVES_ADMIN_ESSG: { permission: LEAVES_ADMIN_ESSG, locationId: 4, locationCode: 'ESSG' },
  LEAVES_ADMIN_ESUK: { permission: LEAVES_ADMIN_ESUK, locationId: 5, locationCode: 'ESUK' },
  LEAVES_ADMIN_ESUS: { permission: LEAVES_ADMIN_ESUS, locationId: 6, locationCode: 'ESUS' },
  LEAVES_ADMIN_ESPH: { permission: LEAVES_ADMIN_ESPH, locationId: 7, locationCode: 'ESPH' },
  LEAVES_ADMIN_ESIE: { permission: LEAVES_ADMIN_ESIE, locationId: 8, locationCode: 'ESIE' },
  LEAVES_ADMIN_ESNZ: { permission: LEAVES_ADMIN_ESNZ, locationId: 9, locationCode: 'ESNZ' },
  LEAVES_ADMIN_ESMY: { permission: LEAVES_ADMIN_ESMY, locationId: 10, locationCode: 'ESMY' },
  LEAVES_ADMIN_ESNL: { permission: LEAVES_ADMIN_ESNL, locationId: 11, locationCode: 'ESNL' },
};
export const PAYSLIP_MENU_VIEW = 'payslip.menu.view';
export const CALENDAR_MENU_VIEW = 'calendar.menu.view';
export const USER_MAINTENANCE_MENU_VIEW = 'user_maintenance.menu.view';
export const REPORT_MENU_VIEW = 'report.menu.view';
export const REPORT_USER_MENU_VIEW = 'report.user.view';
export const REPORT_PROJECT_MENU_VIEW = 'report.project.view';
export const REPORT_DAY_WISE_TIMESHEET_MENU_VIEW = 'report.timesheet.view';
export const USER_MAINTENANCE_USER_VIEW = 'user_maintenance.user.view';
export const USER_MAINTENANCE_USER_CREATE = 'user_maintenance.user.create';
export const USER_MAINTENANCE_USER_ROLE = 'user_maintenance.user.role';
export const USER_MAINTENANCE_USER_MANAGER = 'user_maintenance.user.manager';
export const USER_MAINTENANCE_USER_DESIGNATION = 'user_maintenance.user.designation';
export const USER_MAINTENANCE_ROLE_VIEW = 'user_maintenance.role.view';
export const USER_MAINTENANCE_ROLE_CREATE = 'user_maintenance.role.create';
export const USER_MAINTENANCE_ROLE_EDIT = 'user_maintenance.role.edit';
export const USER_MAINTENANCE_ROLE_DELETE = 'user_maintenance.role.delete';
export const USER_MAINTENANCE_PERMISSION_VIEW = 'user_maintenance.permission.view';
export const USER_MAINTENANCE_PERMISSION_CREATE = 'user_maintenance.permission.create';
export const USER_MAINTENANCE_PERMISSION_EDIT = 'user_maintenance.permission.edit';
export const USER_MAINTENANCE_PERMISSION_DELETE = 'user_maintenance.permission.delete';
export const USER_MAINTENANCE_ROLE_PERMISSION_VIEW = 'user_maintenance.role_permission.view';
export const USER_MAINTENANCE_ROLE_PERMISSION_ADD = 'user_maintenance.role_permission.add';
export const USER_MAINTENANCE_ROLE_PERMISSION_REMOVE = 'user_maintenance.role_permission.remove';
export const USER_MAINTENANCE_MANAGER_VIEW = 'user_maintenance.manager.view';
export const USER_MAINTENANCE_MANAGER_ADD = 'user_maintenance.manager.add';
export const USER_MAINTENANCE_MANAGER_REMOVE = 'user_maintenance.manager.remove';
export const SETTING_LEGAL_ENTITY_VIEW = 'setting.legal_entity.view';
export const SETTING_LEGAL_ENTITY_CREATE = 'setting.legal_entity.create';
export const SETTING_LEGAL_ENTITY_DELETE = 'setting.legal_entity.delete';
export const SETTING_LEGAL_ENTITY_IMPORT = 'setting.legal_entity.import';
export const SETTING_LEGAL_ENTITY_EXPORT = 'setting.legal_entity.export';
export const SETTING_CUSTOMER_VIEW = 'setting.customer.view';
export const SETTING_CUSTOMER_CREATE = 'setting.customer.create';
export const SETTING_CUSTOMER_EDIT = 'setting.customer.edit';
export const SETTING_CUSTOMER_DELETE = 'setting.customer.delete';
export const SETTING_CUSTOMER_IMPORT = 'setting.customer.import';
export const SETTING_CUSTOMER_EXPORT = 'setting.customer.export';
export const SETTING_PROJECT_VIEW = 'setting.project.view';
export const SETTING_PROJECT_CREATE = 'setting.project.create';
export const SETTING_PROJECT_EDIT = 'setting.project.edit';
export const SETTING_PROJECT_DELETE = 'setting.project.delete';
export const SETTING_PROJECT_IMPORT = 'setting.project.import';
export const SETTING_PROJECT_EXPORT = 'setting.project.export';
export const SETTING_ACTIVITY_VIEW = 'setting.activity.view';
export const SETTING_ACTIVITY_CREATE = 'setting.activity.create';
export const SETTING_ACTIVITY_EDIT = 'setting.activity.edit';
export const SETTING_ACTIVITY_DELETE = 'setting.activity.delete';
export const SETTING_ACTIVITY_IMPORT = 'setting.activity.import';
export const SETTING_ACTIVITY_EXPORT = 'setting.activity.export';
export const SETTING_CATEGORY_VIEW = 'setting.category.view';
export const SETTING_CATEGORY_CREATE = 'setting.category.create';
export const SETTING_CATEGORY_EDIT = 'setting.category.edit';
export const SETTING_CATEGORY_DELETE = 'setting.category.delete';
export const SETTING_CATEGORY_IMPORT = 'setting.category.import';
export const SETTING_CATEGORY_EXPORT = 'setting.category.export';
export const SETTING_SKILL_VIEW = 'setting.skill.view';
export const SETTING_SKILL_CREATE = 'setting.skill.create';
export const SETTING_SKILL_EDIT = 'setting.skill.edit';
export const SETTING_SKILL_DELETE = 'setting.skill.delete';
export const SETTING_SKILL_IMPORT = 'setting.skill.import';
export const SETTING_SKILL_EXPORT = 'setting.skill.export';
export const SETTING_DESIGNATION_VIEW = 'setting.designation.view';
export const SETTING_DESIGNATION_CREATE = 'setting.designation.create';
export const SETTING_DESIGNATION_EDIT = 'setting.designation.edit';
export const SETTING_DESIGNATION_DELETE = 'setting.designation.delete';
export const SETTING_DESIGNATION_IMPORT = 'setting.designation.import';
export const SETTING_DESIGNATION_EXPORT = 'setting.designation.export';
export const SETTING_LEAVE_TYPE_VIEW = 'setting.leave_type.view';
export const SETTING_LEAVE_TYPE_CREATE = 'setting.leave_type.create';
export const SETTING_LEAVE_TYPE_EDIT = 'setting.leave_type.edit';
export const SETTING_LEAVE_TYPE_DELETE = 'setting.leave_type.delete';
export const SETTING_LEAVE_TYPE_IMPORT = 'setting.leave_type.import';
export const SETTING_LEAVE_TYPE_EXPORT = 'setting.leave_type.export';
export const SETTING_ACTIVITY_MAP_VIEW = 'setting.activity_map.view';
export const SETTING_ACTIVITY_MAP_MAP = 'setting.activity_map.map';
export const SETTING_CATEGORY_MAP_VIEW = 'setting.category_map.view';
export const SETTING_CATEGORY_MAP_MAP = 'setting.category_map.map';
export const SETTING_USER_CATEGORY_VIEW = 'setting.user_category.view';
export const SETTING_USER_CATEGORY_MAP = 'setting.user_category.map';
export const SETTING_MENU_VIEW = 'setting.menu.view';
export const MASTER_USERS_ADMIN = 'master.users.admin';
export const MASTER_USERS_SUPERVISOR = 'master.users.supervisor';
export const APPLICATION_NOTIFICATION_VIEW = 'application.notification.view';
export const APPLICATION_INOUT_UPDATE = 'attendance.inout.update';
export const APPLICATION_GLOBAL_SEARCH = 'application.global.search';
export const ALLOCATION_MENU_VIEW = 'allocation.menu.view';
export const ALLOCATION_CREATE = 'allocation.create.*';
export const ALLOCATION_REJECT = 'allocation.reject.*';
export const ALLOCATION_APPROVE = 'allocation.approve.*';
export const ALLOCATION_UPDATE = 'allocation.update.*';
export const DOCUMENT_APIDOC = 'document.apidoc.*';
export const DOCUMENT_APPDOC = 'document.appdoc.*';
export const BULK_ATTENDENCE = 'attendance.inout.tm';
export const UPDATE_ATTENDENCE_INOUT_DATE = 'attendance.change.inout.date';

export const Travel_Employee = 'travel.Employee';
export const Team_Travel = 'travel.team.travel';
export const Travel_Desk = 'travel.travel.desk';
export const BU_Head = 'travel.BU.Head';
export const HR_Head = 'travel.HR_head';
export const CEOs = 'travel.CEOs';

export const USER_MAINTENANCE_MENU_ACTION_ROLE_VIEW = 'user_maintenance.menu.action.role.view';
export const USER_MAINTENANCE_MENU_ACTION_MANAGER_VIEW = 'user_maintenance.menu.action.manager.view';


export const CONFIG_SETTING_DATA = 'setting.config.data';

export const HELP_SUPPORT_MENU_VIEW = 'help_support.menu.view';
export const HELP_SUPPORT_TICKET_TAB_VIEW = 'help_support.ticket.tab.view';
export const HELP_SUPPORT_KNOWLEDGE_TAB_VIEW = 'help_support.knowledge.tab.view';
export const HELP_SUPPORT_FAQ_TAB_VIEW = 'help_support.faq.tab.view';

export const SUPPORT_AGENT_MENU_VIEW = 'support_agent.menu.view';
export const SUPPORT_ADMIN_MENU_VIEW = 'support_admin.menu.view';
export const SUPPORT_ADMIN_OVERVIEW_TAB_VIEW = 'support_admin.overview.tab.view';
export const SUPPORT_ADMIN_ALLTICKETS_TAB_VIEW = 'support_admin.alltickets.tab.view';
export const SUPPORT_ADMIN_AGENT_TAB_VIEW = 'support_admin.agent.tab.view';
export const SUPPORT_ADMIN_CATEGORY_TAB_VIEW = 'support_admin.category.tab.view';
export const SUPPORT_ADMIN_SLASETTING_TAB_VIEW = 'support_admin.slasetting.tab.view';
export const SUPPORT_ADMIN_REPORTS_TAB_VIEW = 'support_admin.reports.tab.view';